import { makeAPiQueryParams } from "src/constants/constants";
import { invokeApi } from "src/utils";

// manage products
export const get_product_item_list = async (page, rows, search) => {
  const requestObj = {
    path: `api/items/list_items?page=${page}&limit=${rows}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_item_in_products = async (data) => {
  const requestObj = {
    path: `api/items/add_items`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const edit_product_item = async (id, data) => {
  const requestObj = {
    path: `api/items/update_items/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_product_item = async (id) => {
  const requestObj = {
    path: `api/items/delete_items/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// batch

export const get_batch_list = async (id) => {
  const requestObj = {
    path: `api/batches/list_batches?item_id=${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_batch_to_item = async (data) => {
  const requestObj = {
    path: `api/batches/add_batches`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const edit_batch_of_item = async (id, data) => {
  const requestObj = {
    path: `api/batches/update_batches/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_batch_of_item = async (id) => {
  const requestObj = {
    path: `api/batches/delete_batches/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// shop sale purchase flow

export const get_shop_item_list = async (page, rows, search) => {
  const requestObj = {
    path: `api/items/items_for_shop?page=${page}&limit=${rows}&search=${search}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_all_shop_item = async (type = "") => {
  const requestObj = {
    path: `api/items/items_for_shop_all?type=${type}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const check_today_partial_order = async () => {
  const requestObj = {
    path: `api/orders/check_today_order`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const place_shop_order = async (data) => {
  const requestObj = {
    path: `api/orders/add_order`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const place_shop_order_manually = async (data) => {
  const requestObj = {
    path: `api/orders/add_order_manually`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_shop_order = async (data) => {
  const requestObj = {
    path: `api/orders/update_order`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const get_batches_against_item = async (data) => {
  const requestObj = {
    path: `api/batches/get_batches_against_item`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

// orders listing

export const list_orders_for_employee = async (
  id,
  page,
  rows,
  search,
  filterData,
) => {
  const requestObj = {
    path: `api/orders/list_orders_against_employee?employee_id=${id}&page=${page}&limit=${rows}&search=${search}&item_id=${
      filterData?.item?._id || ""
    }&start_date=${filterData?.date_from || ""}&end_date=${
      filterData?.date_to || ""
    }&status=${filterData?.status == "all" ? "" : filterData?.status || ""}&sponsorship_type=${
      filterData?.sponsorship_type == "all"
        ? ""
        : filterData?.sponsorship_type || ""
    }`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const list_orders_for_admin = async (page, rows, search, filterData) => {
  const requestObj = {
    path: `api/orders/list_orders?page=${page}&limit=${rows}&search=${search}&employee_id=${filterData?.employee?._id || ""}&item_id=${
      filterData?.item?._id || ""
    }&start_date=${filterData?.date_from || ""}&end_date=${
      filterData?.date_to || ""
    }&status=${filterData?.status == "all" ? "" : filterData?.status || ""}&sponsorship_type=${
      filterData?.sponsorship_type == "all"
        ? ""
        : filterData?.sponsorship_type || ""
    }`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const update_order_status = async (orderId, status) => {
  const requestObj = {
    path: `api/orders/update_order_status/${orderId}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: { status },
  };
  return invokeApi(requestObj);
};

export const delete_order = async (orderId) => {
  const requestObj = {
    path: `api/orders/delete_order/${orderId}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

// inventory

export const get_inventory_orders_list = async (
  page = 0,
  rows = 50,
  search = "",
  filterData,
) => {
  const requestObj = {
    path: `api/inventory_orders/get_inventory_orders?page=${page}&limit=${rows}&search=${search}&vendor=${
      filterData?.vendor?._id || ""
    }&start_date=${filterData?.date_from || ""}&end_date=${
      filterData?.date_to || ""
    }&order_status=${filterData?.order_status || ""}&payment_status=${filterData?.payment_status || ""}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
export const get_inventory_orders_detail = async (id) => {
  const requestObj = {
    path: `api/inventory_orders/detail_inventory_order/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const add_inventory_order = async (data) => {
  const requestObj = {
    path: `api/inventory_orders/add_inventory_order`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const edit_inventory_order = async (id, data) => {
  const requestObj = {
    path: `api/inventory_orders/edit_inventory_order/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_inventory_order_payment_status = async (id, data) => {
  const requestObj = {
    path: `api/inventory_orders/update_inventory_order_payment_status/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const delete_inventory_order = async (id) => {
  const requestObj = {
    path: `api/inventory_orders/delete_inventory_order/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
